import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    marginTop: '20px',
  },

  mediaPreview: {
    zIndex: 1,
    height: '100px',
    width: '100%',
    borderRadius: '4px',
    marginBottom: '10px',
    cursor: 'pointer',

    '& svg': {
      fontSize: '40px !important',
    },

    '& img': {
      maxHeight: '120px',
    },
  },

  mediaDialog: {
    borderRadius: '4px',
    overflow: 'hidden',

    '& a': {
      display: 'block',
      height: '100%',
      width: '100%',

      '& img': {
        display: 'block',
        height: '100%',
        width: '100%',
        objectFit: 'cover',
      },
    },
  },
  iconButton: {
    position: 'fixed',
    zIndex: 10,
    top: '7px',
    right: '7px',
    color: 'rgba(0, 0, 0, 0.5)',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
  },

  mediaFull: {
    '& img': {
      maxHeight: '90vh',
      maxWidth: '90vw',
    },
  },
}));
